/**
 * Testimonials Slider JS
 *
 * @since 1.0.0
 * @package uma
 */
(function($) {

	$(document).ready(function() {
		var $testimonialsSlider = $('.testimonials-slider .slider-cards');
		if ($testimonialsSlider.length < 1) {
			return;
		}

        function initFlickityLp() {
            if (window.innerWidth >= 1024) {
                $('.slider-cards').flickity({
                    // options
                    cellAlign: 'center',
                    prevNextButtons: false,
                    selectedAttraction: 0.01,
                    friction: 0.15,
                    initialIndex: 1
                });
            } else {
                $('.slider-cards').flickity({
                    // options
                    cellAlign: 'center',
                    prevNextButtons: false,
                    selectedAttraction: 0.01,
                    friction: 0.15,
                    initialIndex: 0
                });
            }
        }
        initFlickityLp();
        $(window).resize(initFlickityLp);
        
	});

})(jQuery);
